import React, { useState,  useRef } from 'react';
import {
    GoogleMap,
    LoadScript,
    useLoadScript,
    Marker
} from '@react-google-maps/api';

const containerStyle = {
    width: '100%',
    height: '500px'
};

const defaultCenter = {
    lat: 18.74407,
    lng: 73.9700741
};

//function SatelliteMap() {
export const SatelliteMap = () => {
    const { isLoaded } = useLoadScript({
        //*** google map API key
        //AIzaSyAiAdkcZ_8Bzj5FVkUKdi9xAfOD8fb6vrc // old key Umesh sir
        //AIzaSyC16Y-R8bhKWx57M63qEGelyGB3SRfxFIU// New Key Umesh Sir
        //AIzaSyDmmBMzFbZmGwc3FMR90OQNy8K3WFFK9eU" //Milind created new key
        //googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY || "AIzaSyAiAdkcZ_8Bzj5FVkUKdi9xAfOD8fb6vrc",
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY || "AIzaSyDmmBMzFbZmGwc3FMR90OQNy8K3WFFK9eU",

    });
    const [mapType, setMapType] = useState('satellite');
    const [marker, setMarker] = useState(null);
    const [center, setCenter] = useState(defaultCenter);
    const inputRef = useRef();

    // Convert place name to coordinates
    const searchPlace = async () => {
        const place = inputRef.current.value;
        if (!place) return alert("Please enter a place name");
        //const address = 'Samata Society, Ganesh Nagar, Wadgaonsheri, Pune';
       // const address = 'Samata Society, Ganesh Nagar, Wadgaonsheri, Pune';
       // //const url = "https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(address)};
       // const response = await fetch(
       //     `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=AIzaSyDmmBMzFbZmGwc3FMR90OQNy8K3WFFK9eU`
       //);
       // // const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(address)}&limit=1`;

       // const data = await response.json();

       // if (data.status === "OK") {
       //     const location = data.results[0].geometry.location;
       //     setCenter(location);
       //     setMarker(location);
       // } else {
       //     alert("Location not found");
        // }

        //const address = place; //'Alandi,Pune';
        const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(place)}`;
        const response = await fetch(url);
        const data = await response.json();
        alert(data.length);
        if (data.length > 0) {
            const location = {
                lat: parseFloat(data[0].lat),
                lng: parseFloat(data[0].lon)
            };
            alert(`Latitude: ${location.lat}, Longitude: ${location.lng}`);
            setCenter(location);
            setMarker(location);
        } else {
            alert("Location not found");
        }

    };

      return (
        <>
                  <div className="Map">
                      <h3 style={{ color: "#000" }}>Real Time Robot Operation Tracking</h3>
                      <p></p>
                      {!isLoaded ? (
                          <h1>Loading...</h1>
                      ) : (
                 <div>
        
            <div style={{ marginBottom: '10px' }} class="row">
              <div class="col">
                  <input ref={inputRef} type="text" placeholder="Enter place name" />
              </div>
              <div class="col">
                  <button onClick={searchPlace}>🔍 Search</button>
              </div>
              <div class="col">
                  <button onClick={() => setMapType('satellite')}>🌐 Satellite</button>
              </div>
              <div class="col">
                  <button onClick={() => setMapType('roadmap')}>🗺️ Roadmap</button>
              </div>
              <div class="col">
                <button onClick={() => {
                    navigator.geolocation.getCurrentPosition(pos => {
                        const loc = {
                            lat: pos.coords.latitude,
                            lng: pos.coords.longitude
                        };
                        setCenter(loc);
                        setMarker(loc);
                    });
              }}>My Location</button>
              </div>
            </div>
             <GoogleMap
                mapContainerStyle={containerStyle}
                center={center}
                zoom={17}
                mapTypeId={mapType}
            >
             {marker && <Marker position={marker} />}
              </GoogleMap>
            </div>
         )} 
                              
</div >
             
          </>
      );
    
}

export default SatelliteMap;